// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run pnpm gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../../../schema/public';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ThemeGamesListQueryVariables = Types.Exact<{
  first: Types.Scalars['Int']['input'];
  filter: Types.CasinoGameConnectionFilter;
  sort: Types.CasinoGameConnectionSorter;
  language: Types.Scalars['String']['input'];
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  cursor?: Types.InputMaybe<Types.Scalars['String']['input']>;
  hrefPrefix?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ThemeGamesListQuery = { __typename?: 'Query', casino?: { __typename?: 'Casino', id: string, games?: { __typename?: 'CasinoGameConnection', edges?: Array<{ __typename?: 'CasinoGameEdge', node?: { __typename?: 'CasinoGame', id: string, handle?: string, name?: string, thumbUrl?: string, href?: string } }> } } };


export const ThemeGamesListQueryDocument = /*#__PURE__*/ gql`
    query ThemeGamesListQuery($first: Int!, $filter: CasinoGameConnectionFilter!, $sort: CasinoGameConnectionSorter!, $language: String!, $last: Int, $cursor: String, $hrefPrefix: String) {
  casino {
    id
    games(
      sort: $sort
      filter: $filter
      last: $last
      first: $first
      after: $cursor
      language: $language
      hrefPrefix: $hrefPrefix
    ) {
      edges {
        node {
          id
          handle
          name
          thumbUrl
          href
        }
      }
    }
  }
}
    `;
export function useThemeGamesListQuery(baseOptions: Apollo.QueryHookOptions<ThemeGamesListQuery, ThemeGamesListQueryVariables> & ({ variables: ThemeGamesListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ThemeGamesListQuery, ThemeGamesListQueryVariables>(ThemeGamesListQueryDocument, options);
      }
export function useThemeGamesListQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ThemeGamesListQuery, ThemeGamesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ThemeGamesListQuery, ThemeGamesListQueryVariables>(ThemeGamesListQueryDocument, options);
        }
export function useThemeGamesListQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ThemeGamesListQuery, ThemeGamesListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ThemeGamesListQuery, ThemeGamesListQueryVariables>(ThemeGamesListQueryDocument, options);
        }
export type ThemeGamesListQueryHookResult = ReturnType<typeof useThemeGamesListQuery>;
export type ThemeGamesListQueryLazyQueryHookResult = ReturnType<typeof useThemeGamesListQueryLazyQuery>;
export type ThemeGamesListQuerySuspenseQueryHookResult = ReturnType<typeof useThemeGamesListQuerySuspenseQuery>;
export type ThemeGamesListQueryQueryResult = Apollo.QueryResult<ThemeGamesListQuery, ThemeGamesListQueryVariables>;